// extracted by mini-css-extract-plugin
module.exports = {"chat":"Chat_chat__hKGAn","chat-icon":"Chat_chat-icon__7ShBk","chat-component-modal":"Chat_chat-component-modal__29ngR"};